import { render, staticRenderFns } from "./TheAuthTwitter.vue?vue&type=template&id=82cfffb0&"
import script from "./TheAuthTwitter.vue?vue&type=script&lang=js&"
export * from "./TheAuthTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports